import {
  CREATE_MEMBER,
  GET_ACTIVE_CAMPAIGNS,
  NEW_CREATE_MEMBER,
  PAUSE_MEMBER, GET_UPSELL_PRODUCTS,
  NEW_GET_MEMBER, NEW_CREATE_MEMBER_WITH_HASH, GET_MEMBERS_WITH_HASH,
  STOP_MEMBER, UPDATE_PRODUCT_GROUP_SIZE, IS_ELIGIBLE_FOR_RECURRENCE,
  UPDATE_ADDRESS, UPDATE_MEMBER, CREATE_MEMBER_ON_LANDINGPAGE, GET_CANCEL_MONTHS, ACTIVATE_PLEASE_STAY_OFFER,
  GET_MEMBER_STATS, NEW_GET_MEMBERS, APPLY_FOR_RECURRENCE, REMOVE_RECURRENCE, GET_MEMBERSHIP_TYPE_BY_REFERENCE
} from '@/utils/store/actionTypes'
import { AUTH_ID } from '@/utils/store/getterTypes'
import { formatData } from '@/utils/apollo'
import { apolloClient } from '@/utils/store'
import { AttributionCookie } from '@/enums/gtm'
import ActiveCampaigns from '@/apollo/campaign/ActiveCampaigns.graphql'
import GetMemberStats from '@/apollo/member/GetMemberStats.graphql'
import UpdateAddress from '@/apollo/address/UpdateAddress.graphql'
import PauseMember from '@/apollo/member/PauseMember.graphql'
import StopMember from '@/apollo/member/StopMember.graphql'
import CreateMemberOnLandingPage from '@/apollo/member/CreateMemberOnLandingPage.graphql'
import ActivatePleaseStayOffer from '@/apollo/member/ActivatePleaseStayOffer.graphql'
import UpdateMember from '@/apollo/member/UpdateMember.graphql'
import GetCancelMonths from '@/apollo/member/GetCancelMonths.graphql'
import { idPrefixes } from '@/enums/signup'

export default {
  /**
   * Gets the active campaigns
   *
   * @param rootGetters
   * @returns {Promise<void>}
   */
  async [GET_ACTIVE_CAMPAIGNS] ({ rootGetters }) {
    const response = await apolloClient(this).query({
      query: ActiveCampaigns,
      variables: {
        userId: rootGetters[`auth/${AUTH_ID}`]
      },
      fetchPolicy: 'no-cache'
    })

    return formatData(response).data
  },
  /**
   * Create member
   *
   * @param _
   * @param variables
   * @returns {Promise<*>}
   */
  async [CREATE_MEMBER] ({ rootGetters }, { firstName, lastName, address, membershipType, country = '', productGroupSizes = [] }) {
    const userId = rootGetters[`auth/${AUTH_ID}`]
    const otaAttribution = this.$cookies.get(AttributionCookie)

    if (userId && otaAttribution) {
      const sourceUrl = this.app.router.currentRoute.fullPath
      await this.$axios.$put(`${process.env.API_URL}/v2/users/${userId}/attribution`, {
        attribution: {
          ...otaAttribution,
          sourceUrl
        }
      }, {
        headers: {
          ContentType: 'application/json',
          Accept: 'application/json'
        }
      })
    }

    const response = await this.$axios.$post(`${process.env.API_URL}/v2/members`, {
      firstName,
      lastName,
      address: {
        ...address,
        country: country.toUpperCase(),
        countryCode: country.toUpperCase()
      },
      membershipType,
      productGroupSizes
    },
    {
      headers: {
        ContentType: 'application/json',
        Accept: 'application/json'
      }
    })

    return response
  },

  /**
   * Update member
   *
   * @param _
   * @param variables
   * @returns {Promise<*>}
   */
  async [UPDATE_MEMBER] (_, variables) {
    const response = await apolloClient(this).mutate({
      mutation: UpdateMember,
      variables
    })

    const data = formatData(response).data

    return data
  },
  /**
   * Updates the address
   *
   * @param _
   * @param variables
   * @returns {Promise<*>}
   */
  async [UPDATE_ADDRESS] (_, variables) {
    const response = await apolloClient(this).mutate({
      mutation: UpdateAddress,
      variables
    })

    const data = formatData(response).data

    return data
  },

  /**
   * Stop a member.
   *
   * @param _
   * @param variables
   * @returns {Promise<{firstname: string, phoneNumber: string, fullName: string, dateOfBirth: number, id: number, billingAddress: {country: string, streetType: string, city: string, street: string, postalCode: string, houseNumber: number, floor: string, region: string, building: string, annex: string}, email: string, lastname: string, status: string}|{data: null, loading: boolean}|{type: ObjectConstructor, required: boolean}>}
   */
  async [STOP_MEMBER] (_, variables) {
    const response = await apolloClient(this).mutate({
      mutation: StopMember,
      variables
    })

    const data = formatData(response).data

    return data
  },

  /**
   * Pause a member.
   *
   * @param _
   * @param variables
   * @returns {Promise<{firstname: string, phoneNumber: string, fullName: string, dateOfBirth: number, id: number, billingAddress: {country: string, streetType: string, city: string, street: string, postalCode: string, houseNumber: number, floor: string, region: string, building: string, annex: string}, email: string, lastname: string, status: string}|{data: null, loading: boolean}|{type: ObjectConstructor, required: boolean}>}
   */
  async [PAUSE_MEMBER] (_, variables) {
    const response = await apolloClient(this).mutate({
      mutation: PauseMember,
      variables
    })

    const data = formatData(response).data

    return data
  },

  /**
   * Get a members cancel months options.
   *
   * @param _
   * @param memberId
   * @returns {Promise<{}>}
   */
  async [GET_CANCEL_MONTHS] (_, { memberId }) {
    const response = await apolloClient(this).mutate({
      mutation: GetCancelMonths,
      variables: {
        memberId
      }
    })

    return response.data.getCancelMonths
  },

  /**
   * Creates a sock member through the /socks landingpage
   *
   * @param rootGetters
   * @param variables
   * @returns {Promise<*>}
   */
  async [CREATE_MEMBER_ON_LANDINGPAGE] (_, variables) {
    const userId = variables.user.replace(`${idPrefixes.user}`, '')
    const otaAttribution = this.$cookies.get(AttributionCookie)

    if (userId && otaAttribution) {
      const sourceUrl = this.app.router.currentRoute.fullPath
      await this.$axios.$put(`${process.env.API_URL}/v2/users/${userId}/attribution`, {
        attribution: {
          ...otaAttribution,
          sourceUrl
        }
      }, {
        headers: {
          ContentType: 'application/json',
          Accept: 'application/json'
        }
      })
    }

    const { data } = await apolloClient(this).mutate({
      mutation: CreateMemberOnLandingPage,
      variables
    })

    return data
  },

  /**
   * Activates a please stay offer
   *
   * @param _
   * @param variables
   * @returns {Promise<*>}
   */
  async [ACTIVATE_PLEASE_STAY_OFFER] (_, { id, campaignId }) {
    const { data } = await apolloClient(this).mutate({
      mutation: ActivatePleaseStayOffer,
      variables: {
        id,
        campaignId
      }
    })

    return data
  },
  async [GET_MEMBER_STATS] () {
    const { data } = await apolloClient(this).query({
      query: GetMemberStats,
      fetchPolicy: 'no-cache'
    })

    return data
  },
  async [NEW_GET_MEMBERS] () {
    const response = await this.$axios.$get(`${process.env.API_URL}/v2/members`, {
      headers: {
        ContentType: 'application/json',
        Accept: 'application/json'
      }
    })

    return response
  },
  async [NEW_GET_MEMBER] (_, { memberId }) {
    const response = await this.$axios.$get(`${process.env.API_URL}/v2/members/${memberId}`, {
      headers: {
        ContentType: 'application/json',
        Accept: 'application/json'
      }
    })

    return response
  },
  async [UPDATE_PRODUCT_GROUP_SIZE] (_, { memberId, membershipType, productGroupSizes }) {
    const response = await this.$axios.$put(`${process.env.API_URL}/v2/members/${memberId}/product-group-sizes`,
      {
        membershipType,
        productGroupSizes
      },
      {
        headers: {
          ContentType: 'application/json',
          Accept: 'application/json'
        }
      })

    return response
  },
  async [APPLY_FOR_RECURRENCE] (_, { memberId }) {
    const response = await this.$axios.$post(`${process.env.API_URL}/v2/members/${memberId}/recurrence`,
      {},
      {
        headers: {
          ContentType: 'application/json',
          Accept: 'application/json'
        }
      })

    return response
  },
  async [REMOVE_RECURRENCE] (_, { memberId }) {
    const response = await this.$axios.$delete(`${process.env.API_URL}/v2/members/${memberId}/recurrence`)

    return response
  },
  async [IS_ELIGIBLE_FOR_RECURRENCE] (_, { memberId }) {
    const response = await this.$axios.$get(`${process.env.API_URL}/v2/members/${memberId}/recurrence/eligibility`)

    return response
  },
  async [GET_MEMBERSHIP_TYPE_BY_REFERENCE] (_, { membershipTypeReference }) {
    const response = await this.$axios.$get(`${process.env.API_URL}/v2/membership-types/${membershipTypeReference}`)

    return response
  },
  async [NEW_CREATE_MEMBER_WITH_HASH] (_, { id, firstName, lastName, membershipType, productGroupSizes, address, hash }) {
    const otaAttribution = this.$cookies.get(AttributionCookie)

    if (id && otaAttribution) {
      const sourceUrl = this.app.router.currentRoute.fullPath
      await this.$axios.$put(`${process.env.API_URL}/v2/users/${id}/attribution${hash ? `?_hash=${hash}` : ''}`, {
        attribution: {
          ...otaAttribution,
          sourceUrl
        }
      }, {
        headers: {
          ContentType: 'application/json',
          Accept: 'application/json'
        }
      })
    }

    const response = await this.$axios.$post(`${process.env.API_URL}/v2/users/${id}/members?_hash=${hash}`, {
      firstName,
      lastName,
      membershipType,
      productGroupSizes,
      address
    })

    return response
  },
  async [NEW_CREATE_MEMBER] ({ rootGetters }, { firstName, lastName, membershipType, productGroupSizes, address }) {
    const userId = rootGetters[`auth/${AUTH_ID}`]
    const otaAttribution = this.$cookies.get(AttributionCookie)

    if (userId && otaAttribution) {
      const sourceUrl = this.app.router.currentRoute.fullPath
      await this.$axios.$put(`${process.env.API_URL}/v2/users/${userId}/attribution`, {
        attribution: {
          ...otaAttribution,
          sourceUrl
        }
      }, {
        headers: {
          ContentType: 'application/json',
          Accept: 'application/json'
        }
      })
    }

    const response = await this.$axios.$post(`${process.env.API_URL}/v2/members`, {
      firstName,
      lastName,
      membershipType,
      productGroupSizes,
      address
    })

    return response
  },
  async [GET_UPSELL_PRODUCTS] (_, { id, hash = '' }) {
    const response = await this.$axios.$get(`${process.env.API_URL}/v2/users/${id}/upsell-products${hash ? `?_hash=${hash}` : ''}`)

    return response
  },
  async [GET_MEMBERS_WITH_HASH] (_, { id, hash = '' }) {
    const response = await this.$axios.$get(`${process.env.API_URL}/v2/users/${id}/members?_hash=${hash}`)

    return response
  }
}
